import * as Redux from 'redux';
import {
  PaymentRecordDetailActionTypes,
  PaymentsState,
  PaymentRecordDetailsResponse,
  initialPaymentsState,
  PaymentRecordDetail
} from './Types';
import {
  GET_PAYMENT_RECORD_DETAIL,
  REQUEST_COLLECTION,
  REQUESTED,
  RETRY_FAILED_PAYMENT,
  GET_PAYMENT_LIST,
  GET_PAYMENT_DETAILS,
  RIDIRECT_FROM_MEMBER,
  REMOVE_RIDIRECT_FROM_MEMBER,
  REMOVE_PAYMENT_DETAILS
} from './Constants';
import {
  ReduxAction,
  SimpleResponse
} from '../app/app.types';
import {
  REVERT_TO_INITIAL_STATE,
  REVERT_TO_INITIAL_STATE_EXCEPT_AUTH
} from '../app/app.const';
import { DEFAULT_PAYMENT_SCHEDULED } from './Constants';

const paymentsReducer: Redux.Reducer<PaymentsState> = 
  (paymentsState: PaymentsState = initialPaymentsState,
   action: ReduxAction<
   PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>>): PaymentsState => {
  switch (action.type) {
    case `${GET_PAYMENT_DETAILS}_FULFILLED`:
      return { ...paymentsState,
        statusCode: action.payload.statusCode,
        paymentDetails: action.payload.body.entity
      };
    case REMOVE_PAYMENT_DETAILS:
      return { ...paymentsState,
        paymentDetails: undefined
      };
    case `${GET_PAYMENT_LIST}_FULFILLED`:
      return { ...paymentsState,
        statusCode: action.payload.statusCode,
        paymentList: action.payload.body.list
      };
    case `${GET_PAYMENT_RECORD_DETAIL}_FULFILLED`:
      return { ...paymentsState,
        statusCode: action.payload.statusCode,
        paymentRecordDetails: action.payload.body.paymentRecordDetails
      };
    case `${REQUEST_COLLECTION}_FULFILLED`:
      return { ...paymentsState,
        statusCode: action.payload.statusCode,
        paymentRecordDetails:
          getEntityWithGivenId(paymentsState.paymentRecordDetails, action.payload.body.paymentHistoryId)
      };
    case `${RETRY_FAILED_PAYMENT}_FULFILLED`:
      return { ...paymentsState,
        statusCode: action.payload.statusCode
      };
    case RIDIRECT_FROM_MEMBER:
      return { ...paymentsState,
        fromMemberComponent: action.payload.body.entity
      };
    case REMOVE_RIDIRECT_FROM_MEMBER:
      return { ...paymentsState,
        fromMemberComponent: null
      };
    case REVERT_TO_INITIAL_STATE:
      return initialPaymentsState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialPaymentsState;
    default:
      return paymentsState;
  }
};

function getEntityWithGivenId(
  paymentRecordDetails: Array<PaymentRecordDetail>,
  paymentHistoryId: number
): Array<PaymentRecordDetail> {
  if (paymentHistoryId === DEFAULT_PAYMENT_SCHEDULED) {
    return paymentRecordDetails;
  } else {
    return [
      ...paymentRecordDetails.filter((p: PaymentRecordDetail) => p.paymentHistoryId !== paymentHistoryId),
      {
        ...paymentRecordDetails.filter((p: PaymentRecordDetail) => p.paymentHistoryId === paymentHistoryId)[0],
        collectionStatus: REQUESTED
      }
    ];
  }
}

export default paymentsReducer;



// WEBPACK FOOTER //
// ./src/payments/Reducer.tsx